import moment from 'moment';

/**
 * Locale pinned to 'en' when formatting date strings for API calls, Map keys, and string storage
 * Prevents issues caused by postformat function that replaces Latin digits with
 * Eastern Arabic numerals (e.g. "2026" to "٢٠٢٦").
 */
export const API_DATE_LOCALE = 'en';

/**
 * Date-only format for API route parameters and Map keys: YYYY-MM-DD
 */
export const API_DATE_FORMAT = 'YYYY-MM-DD';

/**
 * Formats a moment as a YYYY-MM-DD string safe for API calls, Map keys, and string comparisons.
 * Clones the input to avoid mutating the caller's moment instance.
 * Pins locale to English to prevent Arabic postformat digit substitution.
 */
export function toApiDateString(date: moment.Moment): string {
	return date.clone().locale(API_DATE_LOCALE).format(API_DATE_FORMAT);
}
